import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { AdapterApiService } from "../_adapter";
import { UserModel } from "./models";
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import AdapterUserIdentificationService from "./adapter/AdapterUserIdentificationService";
import PersonalIdentificationData from "@/api/main/dataSource/api/i-public-service/aba-finance/models/user/identification/PersonalIdentificationData";
import ErrorModel from "../login/adapter/models/errorModel";
import { IdentificationNewUser } from "./";
import * as Routes from "@/router/routerNames";
import { AdapterProfileService } from "../profile";


export default /*#__PURE__*/_defineComponent({
  __name: 'user-identification-simple',
  setup(__props) {

const router = useRouter();
const adapter = AdapterUserIdentificationService.getInstance();
const adapterUser = AdapterApiService.getInstance();
const isRedirect = ref(false);
const isVisible = ref(false);

// когда переходим сразу после регистрации
// и данные ще не заполнены то false
const isContinue = ref(false);

onMounted(async () => {
	isContinue.value = !!adapterUser.userInfo.value.FirstName&&!!adapterUser.userInfo.value.LastName
	isVisible.value = isContinue.value;
});

function onContinue() {
	isContinue.value = true;
}

async function Continue(value: UserModel) {
	const req = new PersonalIdentificationData({
		UserId: adapterUser.userInfo.value.Id,
		AddressZip: value.PostCode,
		City: value.City,
		Country: value.CountyState,
		SecondName: value.LastName,
		FirstName: value.FirstName,
		AddressStreet: value.Address1,
	});

	const response = await adapter.saveUserInfo(req);
	
	await AdapterProfileService.getInstance().GetNaturalPerson();
	if (!(response instanceof ErrorModel)) {
		router.push({ name: Routes.NATURALPERSON_PROFILE_IDENTIFICATION });
	}
}

return (_ctx: any,_cache: any) => {
  const _component_identification_start = _resolveComponent("identification-start")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!isContinue.value)
      ? (_openBlock(), _createBlock(_component_identification_start, {
          key: 0,
          onContinue: onContinue
        }))
      : _createCommentVNode("", true),
    (isVisible.value && isContinue.value)
      ? (_openBlock(), _createBlock(_unref(IdentificationNewUser), {
          key: 1,
          onContinue: Continue
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})